import {
  DataPersonName,
  dataPersonName,
  DataStartedAt,
  dataStartedAt,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataPersonsListRequestDTO {
  private static validation = Validate.compile(
    DataPersonsListRequestDTO.validationSchema()
  );

  constructor(readonly data: DataPersonsListRequestDTORaw) {
    Validate.assert(DataPersonsListRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['page'],
      properties: {
        personName: dataPersonName,
        page: {
          type: 'number',
          minimum: 1,
        },
        from: dataStartedAt,
        to: dataStartedAt,
      },
    };
  }
}

interface DataPersonsListRequestDTORaw {
  personName?: DataPersonName;
  page: number;
  from?: DataStartedAt;
  to?: DataStartedAt;
}
